"use strict";

import { knowledgeConstants, participationState } from "../_constants";

export const INITIAL_KNOWLEDGE_STATE = {
    latestQuizzes: [],
    dashboard: {},
    participantQuizzes: [],
    quizzDetails: { questions: [] },
    quizzResults: {},
};

export function knowledge(state = INITIAL_KNOWLEDGE_STATE, action) {
    switch (action.type) {
        case knowledgeConstants.KNOWLEDGE_LATEST_QUIZZES_COMPLETE:
            return {
                ...state,
                latestQuizzes: [...action.payload.data],
            };

        case knowledgeConstants.KNOWLEDGE_PARTICIPANT_QUIZZES_COMPLETE:
            return {
                ...state,
                participantQuizzes: [...action.payload.data],
            };

        case knowledgeConstants.KNOWLEDGE_DASHBOARD_COMPLETE:
            return {
                ...state,
                dashboard: { ...action.payload.data },
            };

        case knowledgeConstants.KNOWLEDGE_QUIZZE_DETAILS_COMPLETE:
            return {
                ...state,
                quizzDetails: { ...action.payload.data },
            };

        case knowledgeConstants.KNOWLEDGE_ANSWER_QUESTION_COMPLETE:
            return {
                ...state,
            };

        case knowledgeConstants.KNOWLEDGE_ENROL_QUIZZE_COMPLETE:
            return {
                ...state,
                quizzDetails: {
                    ...state.quizzDetails,
                    participationState: participationState.IN_PROGRESS,
                    quizAttemptId: action.payload.data,
                },
            };

        case knowledgeConstants.KNOWLEDGE_QUESTION_RESULT_COMPLETE:
            return {
                ...state,
                quizzResults: { ...action.payload.data },
            };
    }

    return state;
}
